import { render, staticRenderFns } from "./replace-access-control-badge-modal.vue?vue&type=template&id=10bd78f7&"
import script from "./replace-access-control-badge-modal.vue?vue&type=script&lang=ts&"
export * from "./replace-access-control-badge-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports